@let firstLevelViewRegion = firstLevelViewRegion$ | async;
@let secondLevelViewRegion = secondLevelViewRegion$ | async;
@let regionToDisplay = secondLevelViewRegion || firstLevelViewRegion;

<div class="dashboard-study-data-view">
  @if (firstLevelViewRegion) {
    <app-dashboard-study-data-view-region
      [viewRegion]="regionToDisplay"
      [activeViewRegionId]="activeViewRegionId"
      [level]="!!secondLevelViewRegion ? 2 : 1"
    ></app-dashboard-study-data-view-region>
  }
</div>
